module.exports = __webpack_public_path__ + "static/media/contact_declined.6b48f383.svg";